<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Dialpad Ai" class="d-icon d-icon--dialpad-ai" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor"><path d="M10.721 2.916a.958.958 0 1 0 0-1.916.958.958 0 0 0 0 1.916Z"/><path fill-rule="evenodd" d="M4.591 2.694c-.217 0-.59.207-.785.841v.002L1.964 9.473a.749.749 0 0 1-1.43-.444l1.84-5.932v-.002c.3-.975 1.084-1.899 2.217-1.899s1.916.922 2.216 1.896l1.417 4.57c.195.633.568.84.785.84a.963.963 0 0 0 .963-.963V4.411a.749.749 0 1 1 1.498 0v3.128A2.46 2.46 0 0 1 9.01 10c-1.132 0-1.916-.92-2.216-1.895l-1.418-4.57c-.195-.633-.567-.84-.785-.84Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDialpadAi',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
